import { Controller, UseFormReturn } from 'react-hook-form';
import { BaseSyntheticEvent, useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { Button, EmailInput, isValidEmail } from '@restworld/ui-ds-base';

import { ModalHeader, ModalSubHeader } from './common';
import { EmailLoginInput } from '../hooks/use-verify-email-form';

export type EnterEmailContentProps = {
  loading?: boolean;
  methods: UseFormReturn<EmailLoginInput, any>;
  onFormSubmit?: (e?: BaseSyntheticEvent) => Promise<void>;
};

export function useEnterEmailContent({ loading, methods, onFormSubmit }: EnterEmailContentProps) {
  const { t } = useTranslation('user-settings');
  const {
    control,
    formState: { errors },
  } = methods;
  const emailError = errors['email']?.message;

  const enterEmailContent = useMemo(
    () => (
      <div className="flex flex-col items-center">
        <ModalHeader className="mb-2 ">{t('email_update_enter_email_step_header')}</ModalHeader>
        <ModalSubHeader className="mb-4">{t('email_update_enter_email_step_subheader')}</ModalSubHeader>
        <div className="flex flex-col gap-8 w-full">
          <Controller
            name="email"
            control={control}
            rules={{ required: t('email_update_enter_email_step_email_required'), validate: isValidEmail }}
            render={({ field }) => (
              <EmailInput
                label={
                  <span>
                    {t('email_update_enter_email_step_email_field')}
                    <span className="text-red-600">*</span>
                  </span>
                }
                onChange={field.onChange}
                variant={emailError ? 'error' : 'primary'}
                supportText={emailError as string}
                value={field.value}
              />
            )}
          />
        </div>
      </div>
    ),
    [control, emailError, t]
  );

  const enterEmailFooter = useMemo(
    () => (
      <Button fullwidth loading={loading} onClick={onFormSubmit}>
        {t('email_update_enter_email_step_button_text')}
      </Button>
    ),
    [loading, onFormSubmit, t]
  );
  return {
    enterEmailContent,
    enterEmailFooter,
  };
}
